const en = {
  navbar: {
    Wallets: "Wallets",
    Transactions: "Transactions",
    WhiteList: "White List",
    Vex: "Virtual Exchange",
    Invoices: "Invoices",
    Card: "Card",
    Fiat_Withdrawal: "Bank Withdrawal",
    ECommerce: "E-Commerce",
    login: "Login",
    logout: "Logout",
    greeting: "Hello",
  },
  Login: {
    title: "Log In",
    welcome: "Welcome back",
    L_mail: "E-Mail",
    P_mail: "example@mail.com",
    L_Password: "Password",
    link_Forgot: "Did you forget your password?",
    SignIn: "You do not have an account?",
    createAccount: "Create account",
    errorCaptcha: "Verify the captcha",
    errorEmail: "Email is bad formmated",
    errorEmpty: "Verify information, fields cannot be empty",
  },
  Forgot: {
    title: "Forgot password",
    L_mail: "E-Mail",
    P_mail: "example@mail.com",
    L_Country: "Country of Nationality",
    link_Forgot: "Do you already have an account? log in",
    btn: "Send Email",
    forgotPage: {
      hi: "Hi",
      L_password: "Password",
      L_cPassword: "Confirm password",
      btn: "Change Password",
    },
  },
  Register: {
    title: "Create New Account",
    L_mail: "E-Mail",
    P_mail: "example@mail.com",
    L_name: "First name",
    L_lastname: "Last name",
    L_country: "Country",
    L_password: "Password",
    L_cPassword: "Confirm password",
    L_card: "Card",
    agree1: "I agree to the ",
    agree2: "Terms and Conditions",
    btn: "Create account",
    link: "Resend email confirmation",
    spam_warning: "If the email hasn't arrived, please check your spam or junk folder.",
    text_already: "Do you already have an account?",
    link_logIn: "Log in",
    confirmation: {
      hi: "Hi",
      yes: "I confirm the email adress is correct",
      btn: "Validate",
      link: "Resend email confirmation",
      M_title: "Resend email",
      L_mail: "E-Mail",
      P_mail: "example@mail.com",
      L_country: "Country",
      M_btn: "Send Email",
    },
    messageError: {
      errorTerms: "You must agree to the terms and conditions",
      errorCaptcha: "Verify the captcha",
      errorEmpty: "Verify information, fields cannot be empty",
      errorCard: "Bad Card format",
      errorEmail: "Email is bad formmated",
      errorPwd: "Both passwords must be similar",
    },
  },
  General: {
    copyToClip: "Copy to clipboard",
    copiedToClip: "Copied to clipboard",
    L_Amount: "Amount",
    P_Amount: "$ USD Amount",
    P_Amount_MXN: "$ MXN Amount",
    P_AmountC: "Crypto Amount",
    N_Amount1t: "You will transfer",
    N_Amount2t: "fee",
    N_Amount3: "Approximately",
    L_AmountAvl: "Available",
    N_Amount1r: "You will receive",
    N_Amount2r: "from this transaction",
    filtros: {
      title_filter: "Date new",
      Date_newest: "Date newest",
      Date_older: "Date older",
      Deposits_lower: "Deposits lower",
      Deposits_bigger: "Deposits bigger",
      Label_ascendant: "Label ascendant",
      Label_descendant: "Label descendant",
      Amount_lower: "Amount lower",
      Amount_bigger: "Amount bigger",
      Category_received: "Category received",
      Category_withdrawal: "Category withdrawal",
      showAll: "Show All",
      Expense: "Expenses",
      Deposits: "Deposits",
    },
    TwoFa: {
      title: "Confirm 2FA",
      desc: "Input the 6-digit code from your Google Authenticator App",
      cancel: "Cancel",
    },
    registerResponse: {
      rejected1: "Your request was rejected.",
      rejected2: "To verify the information",
      click: "Click here!",
      revision: "The information is in the process of revision",
      unregistered1: "You have not completed the registration",
      unregistered2: "To complete your registration",
    },
    PassRequirements: {
      req1: "Must have at least 8 characters",
      req2: "Must contain at least one capital letter",
      req3: "Must contain at least one lowercase letter",
      req4: "Must include at least one digit",
      req5: "Must include at least one special character",
      req6: "Both passwords must be the same",
    },
    months: {
      1: "January",
      2: "February",
      3: "March",
      4: "April",
      5: "May",
      6: "June",
      7: "July",
      8: "August",
      9: "September",
      10: "October",
      11: "November",
      12: "December",
    },
  },
  wallets: {
    Index: {
      Account_overview: "Account overview",
      addresses: "Addresses",
      My_Wallets: "My wallets",
      btn_transfer: "Wirebit Transfer",
      btn_Stransfer: "Request Transfer",
      btn_AddWallet: "Add wallet",
      input_search: "Coin or alias",
      t_h_coin: "coin",
      t_h_alias: "wallet alias",
      t_h_balance: "balance",
      t_h_balanceAprox: "estimated usd balance",
      t_h_date: "date",
      btn_next: "next",
      btn_prev: "prev",
      banner_FinishRegis:
        "Finish your registration to enjoy the full wirebit experience.",
      banner_btnComplete: "Complete",
      banner_AccountType: "Account type",
      banner_CurrentAccount1: "Your account is currently a",
      banner_CurrentAccount2: "account.",
      data_aproxBalance: "Estimated Balance in USD",
      data_Wallets: "Remaining Wallets",
      data_Addresses: "Remaining Addresses",
      modalAdd: {
        title: "Add Wallet",
        wallet: "Wallet",
        S_wallet: "Choose...",
        L_Alias: "Alias",
        P_Alias: "Enter alias",
        L_Pass: "Password",
        N_Pass:
          "*This password will be used for your wallet, not for your account.",
        btn: "Create Wallet",
      },
      modalContract: {
        title: "Agreement Update",
        text: "Dear Wirebit client, we have updated our Service Provision Agreement, we require that you sign again, if you have any questions or comments regarding the agreement you can send an email to hello@wirebit.com",
        continue: "Continue",
      },
      modalTransfers: {
        Tab_interna: "Internal transfer",
        t_i_tooltip: "Transfer funds between your own wallets",
        Tab_externa: "Accounts transfer",
        t_e_tooltip: "Make payments/tranfers to another Wirebit User",
        L_FromWallets: "From Wallet",
        S_Wallets: "Select a wallet",
        L_ToWallets: "To Wallet:",
        L_Amount: "Amount",
        P_Amount: "USD Amount",
        N_Amount1: "You will transfer",
        N_Amount2: "fee",
        N_Amount3: "Approximately",
        L_AmountAvl: "Available",
        L_WalletPass: "Wallet Password",
        P_WalletPass: "Password",
        L_Desc: "Description",
        P_Desc: "Description",
        L_Pass: "Wallet Password",
        P_Pass: "Password",
        L_Alias: "Account Alias",
        P_Alias: "Account Alias",
        L_WAlias: "Wallet Alias",
        P_WAlias: "Wallet Alias",
        btn: "Send Transfer",
        confirmation: {
          title: "Confirm Transfer",
          aprox: "Approx.",
          fromWallet: "From Wallet",
          description: "Description",
          destinyTitle: "Target details",
          accountAlias: "Account Alias",
          walletAlias: "Wallet Alias",
          confirmButton: "Confirm",
        },
      },
      modalRequest: {
        title: "Request Transfer Account",
        L_ToWallets: "To wallet:",
        S_Wallets: "Select a wallet",
        L_Amount: "Amount",
        P_Amount: "USD Amount",
        N_Amount1: "You will transfer",
        N_Amount3: "Approximately",
        L_AmountAvl: "Available",
        L_Desc: "Description",
        P_Desc: "Description",
        copyToClip: "Copy to clipboard",
        copiedToClip: "Copied to clipboard",
      },
    },
    overview: {
      Wallet_overview: "Wallet overview",
      toltip_aliasE: "Edit Alias",
      toltip_aliasS: "Save Alias",
      rangeFrezeF: "Freeze from",
      rangeFrezeT: "to",
      status_Enabled: "Enable",
      status_Disabled: "disable",
      status_Freze: "frozen",
      operations: "OPERATIONS",
      Total_Balance: "Total Balance",
      AproxUSDBalance: "Estimated USD Balance",
      Deposits: "Deposits",
      Withdrawals: "Withdrawals",
      Addresses: "Addresses",
      options: "OPTIONS",
      L_wallet: "Wallet",
      ReqWithdrawal: "Withdrawal",
      changePass: "Change Password",
      EnableWallet: "Enable wallet",
      FreezeWallet: "Freeze wallet",
      btn_With: "Withdrawal",
      btn_Change: "Change",
      btn_Enabled: "Enabled",
      btn_Disabled: "Disabled",
      btn_Freeze: "Freeze",
      btn_UnFreeze: "Unfreeze",
      Transactions: "Transactions",
      seeMore: "See more",
      L_sort: "Sort by",
      L_search: "Search",
      AddressesTitleXrp: "Address Account",
      btn_Add: "Add address",
      btn_AddTag: "Add tag",
      warning_bch:
        "If you’re having problems making a deposit/withdrawal to your bitcoincash account, we remind you that some platforms require you to delete the “bitcoincash:” suffix in order to send your crypto assets successfully.",
      T_h_ADDRESS: "ADDRESS",
      T_h_TAG: "TAG",
      T_h_LABEL: "ADDRESS ALIAS",
      T_h_deposits: "DEPOSITS",
      T_h_date: "DATE",
      T_h_qr: "QR",
      Password: "Password",
      modalWithdrawal: {
        title: "Withdrawal request",
        L_coin: "Coin",
        L_address: "Address",
        L_Description: "Description",
        L_Amount: "Amount",
        L_Available: "Available",
        N_Amount1: "You will receive",
        N_Amount2: "from this transaction",
        N_Amount3: "Approximately",
        btn: "Send Withdrawal",
        L_Tag: "Tag",
        select: "Select an address",
        invalidAddrss: "The captured address is invalid",
        invalidOmni:
          "The target address must match the withdrawal network: Omni",
        network: "Network",
        invalidSolana:
          "The target address must match the withdrawal network: Solana",
      },
      modalChangePass: {
        title: "Change wallet password",
        L_NewPass: "New password",
        L_ConfirmPass: "Confirm password",
        L_ReqPass: "Password requirements",
        L_current: "WBD account password",
        req_1: "Must have at least 8 characters",
        req_2: "Must contain at least one capital letter",
        req_3: "Must contain at least one lowercase letter",
        req_4: "Must include at least one digit",
        req_5: "Must include at least one special character",
        req_6: "Both passwords must be the same",
        btn: "Change",
      },
      modalWalletLockFreeze: {
        titleWL: "Wallet lock",
        titleWF: "Freeze wallet",
        L_DateFrom: "Date from",
        L_DateTo: "Date to",
        AccountPassword: "WBD account password",
        WalletPassword: "Wallet password",
      },
      modalWithdrawalInfo: {
        title: "Withdrawal Conditions",
        L_TransFee: "Transaction Fee",
        L_Address: "Address",
        D_Address: "Address must be valid",
        MinWith: "Minimum Withdrawal Amount",
        L_TransferFee: "Transfers Fee",
        D_TrasnferFee_i: "Internal",
        D_TrasnferFee_a: "Accounts",
        D_TrasnferFee_iv: "Invoices",
      },
      modalFreeze: {
        title: "Freeze wallet",
        L_DateF: "Date from",
        L_DateT: "Date to",
        btn: "Freeze Wallet",
      },
    },
    transacciones: {
      header_1: "Wallet USD balance",
      header_2: "Wallet balance",
      header_3_E: "Enabled",
      header_3_D: "Disabled",
      header_3_F: "Freeze",
      header_4: "Deposits",
      header_5: "Withdrawals",
      title: "Transactions",
      exportCSV: "Export to csv",
      goBack: "Go back wallet",
      L_sort: "Sort by",
      L_search: "Search",
      L_dateF: "Date from",
      L_dateT: "Date to",
      T_H_WA: "wallet / address",
      T_H_category: "category",
      T_H_label: "label",
      T_H_status: "status",
      T_H_amount: "amount",
      T_H_USDamount: "USD amount",
      T_H_date: "date",
      T_H_txid: "txid",
    },
  },
  transacciones: {
    title: "Account transactions",
    exportCSV: "Export to csv",
    L_sort: "Sort by",
    L_search: "Search",
    L_dateF: "Date from",
    L_dateT: "Date to",
    T_H_WA: "wallet / address",
    T_H_category: "category",
    T_H_label: "label",
    T_H_status: "status",
    T_H_amount: "amount",
    T_H_USDamount: "USD amount",
    T_H_date: "date",
    T_H_txid: "txid",
    tooltip_hover: "Wallet alias",
  },
  whitelist: {
    alert:
      "Your white list is disabled, you can enable this feature through your settings window",
    title: "Addresses",
    addAddrss: "Add Address",
    L_Coin: "Coin",
    L_SelectCoin: "Select a coin",
    L_Status: "Status",
    L_StatusE: "Enabled",
    L_StatusD: "Disabled",
    L_SelectStatus: "Select a status",
    L_Search: "Search",
    T_H_WA: "wallet / address",
    T_H_label: "label",
    T_H_status: "status",
    T_H_maxAmount: "max amount",
    ModalAddAddress: {
      title: "Add Address to White List",
      L_Wallet: "Wallet",
      L_Address: "Address",
      L_AddressError: "The captured address is invalid",
      L_Tag: "Tag Id",
      L_Label: "Label",
      L_Amount: "Amount",
      P_Amount: "USD Amount",
      L_Amountn1: "Approximately",
      L_Amountn2:
        "Amount: limits the maxium amount of crypto that can be transfered on a single transaction",
      btn: "Add Address",
    },
    ModalEditAddress: {
      L_TagId: "Tag Id",
      L_label: "Label",
      L_MaxAmount: "Max Amount",
      L_MaxAmountAprox: "Approximately",
      P_Amount: "Amount",
      P_Amount2: "USD Amount",
      L_Status: "Status",
      btn: "Save Changes",
    },
  },
  VEX: {
    wallet: "Wallets",
    addresses: "Addresses",
    get: "Get",
    titleEX: "Exchange",
    intrument_exchange: "Instrument you exchange",
    intrument_get: "Instrument you get",
    tdc: "Card payment",
    Fee: "Fees",
    exchange_from: "From",
    exchange_to: "To",
    virtualUSD: "Virtual USD",
    placeholder_coin: "Select Instrument",
    market_price: "Market Price",
    L_selectWallet: "Select wallet",
    selectWallet: "Select a wallet",
    walletBalance: "Wallet balance",
    t_h_instrument: "Instrument",
    balance: "My balance",
    L_Pair: "Pair",
    L_Amount: "Amount",
    USDApprox: "Estimated USD Value",
    btn_buy: "market buy",
    btn_sell: "market sell",
    titleT: "Transactions",
    L_sort: "Sort by",
    L_dateF: "Date from",
    L_estimated: "Estimated",
    L_dateT: "Date to",
    L_search: "Search",
    T_H_pair: "PAIR",
    T_H_wallet: "WALLET",
    T_H_category: "CATEGORY",
    T_H_amount: "AMOUNT",
    T_H_price: "PRICE",
    T_H_status: "STATUS",
    T_H_date: "DATE",
    emptyWallet: "Please add a wallet to continue the process",
    modalCreateOrder: {
      title: "Create order",
      confirm: "Confirm exchange order",
      WalletSelected: "Wallet selected",
      MarketB: "Market buy",
      MarketS: "Market sell",
      Amount: "Amount",
      Confirm: "Confirm",
      Cancelar: "Cancel",
      get: "You get",
      fee: "Fee",
      From: "From",
      To: "To",
      price: "Market price",
    },
    transacciones: {
      title: "Transactions",
      L_sort: "Sort by",
      L_search: "Search",
      L_dateF: "Date from",
      L_dateT: "Date to",
      T_H_Pair: "Pair",
      T_H_WA: "wallet",
      T_H_category: "category",
      T_H_amount: "amount",
      T_H_Price: "price",
      T_H_status: "status",
      T_H_date: "date",
    },
  },
  Card: {
    riseLimit:{
      btn_link_rise: 'Increase deposit limit',
      title: 'Request deposit limit increase',
      label_ammount: 'Desired increase (USD)',
      label_reason: 'Request description',
      calculated_amount: 'Approx.',
      placeholder_amount: 'USD amount',
      count_characters: 'Max. 250 characters',
      btn_send_request: 'Send request',
      modal_confirm: 'Request successfully sent',
      msg_confirm: 'We will notify you via email\n once it is authorized.',
      btn_close: 'Close'
    },
    disabled: {
      note1: "Please request you Wirebit Card here",
      btn: "Request card",
      note2:
        "shipping fee after approval (Available to pay with any of your wallets)",
      note3: "",
    },
    payment: {
      title: "Card Payment",
      L_Wallet: "Wallets",
      P_Wallet: "Select a wallet",
      L_Description: "Description",
      P_Description: "Card Payment",
      L_pass: "Password",
      P_pass: "Wallet Password",
      btn: "Send Payment",
    },
    assignation: {
      title: "Your card is on the way, register it once it arrives",
      btn: "Register",
      M1_title: "Add card",
      M1_L_input: "Input the 16 digits of your card",
      M1_btn: "Validate",
      M2_title: "Card registered!",
      M2_PinNote: "The PIN for your card is",
      help_text: "Need help?",
      contact_text: "Contact us",
    },
    transaction_list: "No transactions found in the selected date range",
    enabled: {
      L_Status: "Status",
      L_StatusU: "Unlocked",
      L_StatusB: "Locked",
      btn_StatusU: "Unblock",
      btn_StatusB: "Block",
      L_Detail: "Detail",
      L_Card_Digital: "Digital card",
      btn_Pin: "Request Pin",
      tab_deposit: "Deposit to Card",
      tab_Withdra: "Withdrawal from Card",
      L_avlDeposit: "Available to deposit",
      L_avlWithdra: "Available to withdrawal",
      L_Transaction: "Transactions",
      btn_Deposit: "Deposit",
      btn_withdra: "Withdrawal",
      note_Deposit1: "Deposit limit per month in this card is",
      note_Deposit2: "If you require a bigger deposit amount",
      btn_Link_increase: "Increase deposit limit",
      note_Withdra: "Withdrawal limit per month in this account",
      cardBalnce: "Card Balance",
      virtualUSD: "Virtual USD Balance",
      L_operations: "Operations",
      L_DateFrom: "Date from",
      L_DateTo: "Date to",
      L_empty_transactions_1: "For the moment there are no",
      L_empty_transactions_2: "movements available",
      L_add_card: "Add Card",
      Btn_new_Card: "+ New Card",
      btn_accept: "Accept",
      modalRegister: {
        success: {
          title: "Card added",
          subtitle: "Your card was successfully added",
          btn_init: "Begin",
        },
        failed: {
          title: "Invalid Card",
          msg: "It seems there was a problem with your card,\n try again or contact one of\n our executives.",
          btn_back: "Return",
          btn_contact: "Contact us",
        },
      },
      modalPin: {
        title: "Request PIN",
        note: "In order to recive your PIN we'll need to verify your identity with an sms verification code sent to your phone",
        btn_Send: "Send Verification Code",
        link: "Already have your verification code?",
        title2: "Input Verification Code",
        L_code: "Verification Code",
        P_code: "Enter Code",
        btn_request: "Request PIN",
        success: "Success",
        L_Pin: "Your Card PIN is",
      },
      modalTransaction: {
        title: "Movement details",
        L_organization: "Organization",
        L_withdrawal_account: "Withdrawal account",
        L_amount: "Amount",
        L_movement_type: "Movement type",
        L_concept: "Movement concept",
        L_commerce: "Commerce",
        L_reference_number: "Reference number",
        L_unrecognized: "Unrecognized movement",
      },
      modalBlockDigital: {
        title: "Block Card",
        titleUnblock: "Unblock Card",
        body: "Are you sure you want to block your\n card? You won't be able to use it\n until you unblock it again. ",
        bodyUnblock:
          "Are you sure you want to unblock your\n card? It will become active again\n and ready to use.",
      },
      modalBlockPhysical: {
        title: "Block Card",
        titleUnblock: "Unblock Card",
        body: "Are you sure you want to block your\n card? You won't be able to use it\n until you unblock it again. ",
        bodyUnblock:
          "Are you sure you want to unblock your\n card? It will become active again\n and ready to use.",
      },
      modalSettings: {
        title: "Configuration",
        L_reposition: "Card replacement",
        L_cancel: "Cancel card",
      },
      modalCardReplacement: {
        title: "Card replacement",
        L_body: "Please call the following number:",
        L_cancel: "Cancel",
      },
      modalCardCancelation: {
        title: "Cancel card",
        L_body: "Please call the following number:",
        L_cancel: "Cancel",
      },
      modalUnrecognized: {
        title: "Unrecognized movement",
        L_body: "Please call the following number:",
        L_cancel: "Cancel",
      },
      physicalCard: {
        title: "Physical Card",
        L_card_number: "Card number",
        L_copy: "Copy",
        L_expiration_date: "Expiration date",
        L_pin: "Pin",
        L_config: "Configuration",
        L_card_copied_title: "Done!",
        L_card_copied_message: "Card number has been copied to clipboard!",
      },
      digitalCard: {
        title: "Digital card",
        L_card_number: "Card number",
        L_copy: "Copy",
        L_expiration_date: "Expiration date",
        L_cvv: "CVV",
        L_hide: "Hide",
        L_show: "Show",
        L_time_warning_1: "Your CVV security code,",
        L_time_warning_2: "will only be valid for 5 minutes",
        L_card_copied_title: "Done!",
        L_card_copied_message: "Card number has been copied to clipboard!",
      },
    },
    warning: {
      msg: "The service is in maintenance.",
    },
  },
  settings: {
    tab_Personal: "Personal Information",
    tab_Bank: "Bank Information",
    tab_Services: "Services",
    personal: {
      title: "Information",

      titleAccount: "Accounts information",
      L_email: "Email",
      L_name: "Name",
      L_Country: "Country",
      L_Status: "Status",
      L_Last_Login: "Last Login Date",
      L_Registration_Date: "Registration Date",

      titleBasic: "Basic information",
      L_FistName: "First Name",
      L_fatherLastName: "Father's surname",
      L_motherLastName: "Mother's surname",
      L_DateBirth: "Date of Birth",
      L_Country: "Country of Nationality",
      L_Curp: "CURP",
      L_rfc: "RFC / Tax ID",
      L_Profession: "Economic Activity / Profession",

      titleCompany: "Company information",
      bussines_name: "Business Name",
      bussines_country: "Country of Incorporation",
      bussines_date: "Date of Incorporation",
      bussines_rfc: "RFC / Tax ID",
      bussines_line: "Line of Business",
      titleRepresentative: "Legal representative information",
      L_CountryBirth: "Country of Birth",

      titleAddress: "Address information",
      Addss_Country: "Country",
      Addss_State: "State/ Department/ Provinces",
      Addss_Municipio: "Municipality / Delegation",
      Addss_City: "City",
      Addss_Colony: "Colony/ Residential Complex",
      Addss_Street: "Street, avenue or road",
      Addss_id: "Address ID / External number / name",
      Addss_Int: "Internal Number",
      Addss_Zip: "Zip code",
    },
    bank: {
      title: "Bank information",
      bk_status: "Bank request status",
      bk_name: "Bank name",
      bk_country: "Bank country",
      bk_state: "Bank state",
      bk_city: "Bank city",
      bk_zip: "Bank zip code",
      bk_address: "Bank address",
      bk_Intermediary: "Bank Intermediary",
      bk_BillingAddss: "Billing Address",
      bk_accountNumber: "Bank Account Number",
      bk_currency: "Account Currency",
      bk_Aba: "ABA",
      bk_swift: "SWIFT",
      bk_spid: "SPID",
      bk_CLABE: "CLABE of bank account",
      btn_remove: "Remove Bank",
      btn_add: "Add Bank",

      bk_statement: "Bank Cover Sheet, Account Statement",

      L_applicable: "if applicable",

      btn_save: "Save Bank",
    },
    services: {
      titleApiKeys: "Api Keys",
      T_H_api: "Api Keys",
      T_H_status: "STATUS",
      T_H_lastUse: "LAST USE",
      T_H_apiSecret: "API SECRET",
      T_H_apiTOTP: "API TOTP",
      btnCreateKey: "Create API Key",

      L_Alias: "Wirebit Account Alias",
      btn_Alias: "Change transfer Alias",
      L_Passwor: "Change Password",
      L_whiteList: "White List",
      L_status: "Status",
      L_statusE: "enabled",
      L_statusD: "disabled",
      btn_statusE: "Enable",
      btn_statusD: "Disable",

      L_lang: "language",
      L_langE: "English",
      L_langS: "Spanish",

      modalAlis: {
        L_newAlias: "New Transfer Alias",
        note: "Note: Choose wisely your Alias. Do not use special characters or spaces, 8 min to 32 max characters",
        btn_save: "Save Changes",
      },
      modalChangePass: {
        L_current: "Current Password",
        L_new: "New Password",
        L_confirm: "Confirm Password",
        L_requirements: "Password Requirements",
        btn_Cancel: "Cancel",
      },
      modalTwoFa: {
        mA_open: "Open your Google Authenticator App",
        mA_Select: "Select the Scan Barcode button",
        mA_Scan: "Scan the following QR",
        mA_scaned: "Already Scanned the QR",
        btn_Cancel: "Cancel",
        btn_Back: "Back",

        titleA: "Activate 2FA",
        titleD: "Deactivate 2FA",

        warning:
          "WARNING: We highly recommend you to always use 2FA Authentication to keep your account and transactions safe",
      },
    },
  },
  Withdrawal: {
    L_W_type: "Withdrawal Type",
    L_W_typeC: "Card",
    L_W_typeB: "Bank transfer",
    note: "This section is for withdrawals from your Virtual USD/MXN to your bank or to your card",
    note2:
      "This section is for withdrawals from your Virtual USD/MXN to your bank",

    L_name: "Name",
    L_email: "Email",
    L_Card: "Card",
    L_Amount: "Withdrawal Amount",
    L_Available: "Available",
    L_AmountNote: "You will withdraw approximately",
    L_note:
      "Minimum transfer amount $40 usd. Transfers will take 24 to 72 business hours.",
    L_note_mxn:
      "Minimum transfer amount $800 mxn. Transfers will take 24 to 72 business hours.",

    btn_send: "Request Withdrawal",

    L_note_bk:
      "You do not have bank information or it is in the process of being authorized",
    L_note2_bk: "To fill out your bank information or check your status",

    L_selectBank: "Select a bank account",
  },
  invoice: {
    title: "Payment Invoice",
    deadline: "Deadline",
    T_H_coin: "Coin",
    T_H_addss: "Payment Address",
    T_H_Calcu: "USD Calculator",
    Notice1: "Notice: This are USD approximations using local prices",
    Notice2: "Please feel free to calculate your own amounts",
    btn_Pay: "Pay Invoice",

    M_title: "Invoice Payment",
    L_wallet: "Wallets",
    P_wallet: "Select a wallet",
    L_address: "Address",
    L_description: "Description",
    L_password: "Password",
    btn_send: "Send Payment",

    titleHistory: "Payment History",
    T_H_priod: "Period",
    T_H_status: "Status",
    Invoice: "Invoice",
    L_billed: "Billed to",
    L_legalRep: "LEGAL REPRESENTATIVE",
    L_street: "STREET ADDRESS",
    L_country: "COUNTRY",
    L_CELLPHONE: "CELLPHONE",
    L_info: "Invoice infromation",
    L_coin: "COIN",
    L_status: "STATUS",
    L_DATE: "DATE",
    btn_download: "Download",
    L_AMOUNT: "AMOUNT",
    note: "For more information, please contact us at",
  },
  kyc: {
    choose: {
      title_mobile: "Choose your entity type",
      title: "Choose your entity type",
      subtitle: "All files should be .jpeg, .png, .jpg or .pdf\nand must not exceed 8MB",
      desc: "Physical person or moral person",
      description: "You will need the following files and information:",
      physical: "Physical person",
      p_req: "RFC / TAX ID",
      p_req1: "ID Front and back or Passport",
      p_req2: "Selfie ID",
      p_req3: "Proof of address",
      p_req4: "General client information",
      youHave: "You have this plan",
      moral: "Moral person",
      m_req_0: "RFC / Tax ID: Legal representative and company",
      m_req: "ID Front and back or Passport",
      m_req1: "Selfie ID",
      m_req2: "Articles of incorporation",
      m_req3: "Proof of address",
      m_req4: "Legal representative information",
      m_req5: "General business information",

      plan_desc: "You will need the following files and information",
      plan_files_format: "All files should be .jpeg, .png, .jpg or .pdf",

      L_Continue: "Continue",
      L_Choose: "Choose",

      M_cell_title: "Cell Phone Verification",
      M_cell_note:
        "Please enter the code that was sent to the number you entered",
      M_cell_code: "Code",
      M_cell_CaptureCode: "Capture the code",
      M_cell_valid: "Validate",
      M_cell_resend: "Resend code",
      M_cell_change: "Change phone number",
      M_cell_verif: "Cell Phone Verification",
      M_cell_note2: "Please verify a cell phone number before choosing a form",
      M_cell_phone: "cell phone",
      M_cell_btn: "Send Code",
    },
    form: {
      header_1: "Basic Information",
      header_2: "Address",
      header_3: "Bank Information (optional)",
      finalmsg: "Your registration was successfully completed!",
      subtitle1: "Create you first",
      subtitle2: "Wallet",
      subtitle3: "and apply for you",
      subtitle4: "Wirebit Card",
      textWallet_1: '1. Go to the “My Wallets” section. Click on the “Add Wallet” button.',
      textWallet_2: '2. Select the cryptocurrency of your choice, choose an alias and create a password for that wallet.',
      textWallet_3: '3. Create an address where you can fund your wallet.',
      textWallet_4: '4. Request your card in the “Card” section.',
      textWallet2: 'Start using all the potential',
      textWallet3: 'Wirebit',
      textWallet4: 'has for you.',
      btnCreateWallet: 'Create wallet',
      GoHome: "Go home",
      general: {
        Name: "First Name",
        Father_Surname: "Father's Surname",
        Mother_Surname: "Mother's Surname",
        Date_Birth: "Date of Birth",
        Country_Birth: "Country of Birth",
        RFC: " / Tax ID",
        fiscalID: 'Tax ID',
        Nationality: "Nationality",
        EconomicAct: "Economic Activity / Profession",
        idPassportNum: "ID or Passport number",
        selfieID: 'Selfie ID',
        idFront: 'Front ID',
        idBack: 'Back ID',
        IdF: "Legal Representative ID (front)",
        idB: "Legal Representative ID (back)",
        id: "ID (Front and back view)",
        Passport: "Passport number",
        Articles_Incorporation: "Articles of Incorporation",
        Last_Articles_Incorporation:
          "Last modification of Articles of Incorporation",
        Continue: "Continue",
        optional: "optional",
        skip: "Skip",
        if_applicable: "if applicable",
      },
      moral: {
        Business_Name: "Business Name",
        Date_Incorporation: "Date of Incorporation",
        country: "Incorporation Country",
        Line_Business: "Line of Business",
        part2: "Legal representative information",
        Public_register: "Public register",
        company: "Company",
        legalRep: "Legal representative",
        help_tools: {
          bussines_name: "Bussines Name",
          bussines_name_description: 'Legal name under which the\n company is registered',
          birthdate_company_description: 'Date on which the company\n was legally incorporated',
          country_incorporation_description: 'Country in which the company\n was legally incorporated',
          rfc_company_description: 'Tax identification Number (TIN),',
          rfc_company_description_2: 'the name may vary in each country',
          selfie_id : 'Take a selfie (photograph) holding your\n ID in your hand',
          selfie_id_description_2: 'Do not cover your ID photo with your\n hand or fingers',
          selfie_id_description_3: 'Take the selfie in a well-lit area',
          selfie_id_description_4: 'Make sure your photo is clear',
          f_constitutive_act_description: 'Testimony or certified copy of the\n public instrument that accredits\n its constitution and registration in\n the corresponding public registry.',
          f_constitutive_act_description_2: 'Incorporation act of the company',
          curp_description: 'The Unique Population Registry Code for\n Mexican citizens and residents',
          passport_title: 'Passport number',
          passport_description: 'You can find the passport number in the top\n right-hand corner of your passport laminate',
          id_title: 'ID Number',
          id_description: 'A combination of letters and numbers that\n identify the credential, not the person.\n Its position varies depending on the country',
          f_utility_bill_title: 'Proof of Address',
          f_utility_bill: 'The document must be less than 3 months old\n (electricity, water, landline phone bill,\n bank statement)'
        }

      },
      address: {
        country: "Country",
        state: "State",
        P_state: "State / Department / Provinces",
        T_state:
          "The state where you reside, states have Governors, Example: State of Florida, State of Nuevo Leon, Department of Antioquia.",
        delegation: "Delegation",
        P_delegation: "Delegation / Municipality / County",
        T_delegation:
          "Delegation, Municipality where you reside, municipalities have a Mayors, Example: New York County, Municipality of Bogota.",
        city: "City",
        Neighborhood: "Neighborhood",
        P_Neighborhood: "Neighborhood / Residential Complex / Sector",
        T_Neighborhood:
          "The area where you live, the area where your address is located",
        Street: "Street",
        P_Street: "Street / Avenue / Road",
        BuildingNumber: "Building number / House",
        Apartament: "Apartament / Office Number",
        ZipCode: "Zip Code",
        ProofAddress: "Proof of Address",
      },
      bank: {
        note: 'If you don’t require any deposit to your bank account you can dismiss this step and click on the bottom "skip" button. If you skip this step you can upload your bank information on the settings section and on the bank information tab.',
        b_name: "Bank name",
        b_country: "Bank country",
        b_state: "Bank state",
        b_city: "Bank city",
        b_zipCode: "Bank zip code",
        b_address: "Bank address",
        b_Intermediary: "Bank Intermediary",
        b_BillingAddress: "Billing address",
        b_AccountNumber: "Bank Account Number",
        b_AccountCurrency: "Bank Account Currency",
        b_Currency: "Account Currency",
        b_CLABE: "CLABE of bank account",
        b_Account_Statement: "Bank Cover Sheet, Account Statement",
      },
      Contract: "Contract",
      Clear: "Clear",
      Confirm: "Confirm",
      Signature: "Signature",
    },
  },
  ecomm: {
    modal: {
      title: "You don't have an e-commerce",
      text: "It's as easy as filling the form",
      button: "Start now!",
    },
    msg_validation: 'Maximum of 18 characters',
    myecomm: "My business",
    vextitle: "Exchange to",
    goBack: "Go Back",
    fiatW: "FIAT withdrawal",
    download_btn: "Download",
    auto: {
      disabled: "Manually",
      enabled: "Automatically",
    },
    0: "Manually",
    daily: "Daily",
    48: "Every 48 hours",
    history: "Transactions received",
    b_devices: "Devices",
    b_addDevice: "Add a device",
    b_wallets: "Wallets",
    b_settings: "Settings",
    b_thats: "That's it web",
    starting_date: "Starting Date",
    ending_date: "Ending Date",
    search: "Search",
    order: "Order",
    source: "Source",
    terminal_name: "Source",
    device: "Device",
    address: "Address",
    tag_id: "Tag ID",
    amountUSD: "Amount",
    btn_export: "Export to csv",
    wb_transfer: "Wirebit Transfer",
    fecha: "Creation date",
    devices: "Device",
    create_date: "Creation Date",
    confirm_date: "Confirmation Date",
    crypto: "Crypto",
    state: "Status",
    seeMore: "See more",
    delete: "Delete",
    btn_transfer: "Wirebit Transfer",
    coin: "Coin",
    email: "E-Mail",
    apititle: "API Keys",
    status: "STATUS",
    documentation: "API Documentation",
    select_cripto:
      "Select the cryptos that you wish to accept in your business",
    tolerance: "Tolerance range",
    select_tolerance: "Tolerance range allows.",
    banks: "Withdrawal bank accounts",
    select_withdrawal: "Select the frequency of FIAT withdrawals",
    fiat_alert:
      "For Fiat withdrawals it is required that you finish your account ",
    kyc: "KYC",
    fiat_alert_2: " and have one approved bank account",

    vex_alert:
      "In order to exchange your crypto into V-USD you need to finish your account ",
    select_currency: "Select a virtual currency for your ecommerce",
    vex_receive: "Exchange incomming crypto to",
    vex_receive2: "Automatically",
    info_fee: "Exchanging crypto into",
    info_fee2: "will charge you a fee of",
    notification_options: "Notification Settings",
    mail_create: "Receive e-mail when an order is created with crypto payment.",
    mail_complete: "Receive e-mail when a payment is complete.",
    url: "Return URL",
    refInput: "Reference display title",
    web_name: "Web Addresses",
    pin_txt: "Use a pin to protect your That's it web",
    save: "Save Changes",

    client_info: "Client information",
    order_details: "Order details",
    product: "Product",
    quantity: "Quantity",
    usdPrice: "Price",
    payments: "Order payments",
    mark_complete: "Mark order as complete",
    ex_value: "Crypto/",
    expected: "Expected crypto",
    received: "Received crypto",
    missing: "Missing crypto",

    setup: "E-Commerce set up",
    name: "E-Commerce name",
    image: "E-Commerce logo",
    trans_config: "Transactions configuration",
    wallets: "Wallets",
    wallets_password: "Wallets' Password",
    estimated_usd: "Estimated balance in USD",
    estimated_mxn: "Estimated balance in MXN",
    deviceName: "Name",
    deviceUser: "User",
    deviceCoin: "Coin",
    deviceStatus: "Status",
    devices_status: {},
    deviceName: "Device Name",
    deviceUserName: "User Name",
    deviceCoin: "Currency",
    continue: "Continue",
    scan: "Scan QR",
    typeCode: "Type the 6 digit code displayed on the device",
    deviceSuccess: "Device added successfully!",
    theDevice: "The device",
    deviceReady: "is ready to use",
    finish: "Finish",
    deviceModalTitle:
      "Enjoy the benefits of generating orders straight from your phone.",
    deviceModal1: `1. Download the app “That's it” from the app store on your phone.`,
    deviceModal2:
      "2. Follow the instructions to link your device to your e-commerce.",
    send_email_order: "Mail send success!",
    title_send_email_order: "Success",
    error_send_email_order: "Something went wrong, try again later",
    title_error_send_email_order: "Error!",
    btn_send_email: "Send mail",
  },
  services: {
    title: "Utilities",
    step1: "1. Choose the bill you wish to pay",
    step2: "2. Fill the required fields to complete your payment",
    step3: "3. Select the wallet you wish to pay with",
    referenceNum: "Reference Number",
    continue: "Continue with payment",
    amount: "Amount",
    reference: "Reference Number",
    coin: "Coin",
    wallet: "Wallet",
    wallet_alias: "Wallet Alias",
    mxn_price: "MXN Price",
    crypto_price: "Crypto Price",
    goBack: "Go Back",
    seeTrans: "Payment history",
    legend: "Only payments with issued receipts for services rendered are accepted.",
    summary: {
      title_1: "Service payment summary",
      title_2: "Payment method",
      confirm: "Confirm Payment",
      confirmPass: "Confirm password",
      walletPass: "Wallet password",
    },
    receipt: {
      title: "Confirmation of successful payment!",
      cap1: "Date of payment",
      cap2: "Service to be paid",
      cap3: "Reference",
      cap4: "Total Price in Crypto",
    },
    transactions: {
      title: "Payment history",
      header: {
        Wallet: "Wallet",
        Servicio: "Utility",
        Label: "Label",
        Status: "Status",
        Amount: "Amount",
        MXN_Amount: "MXN Amount",
        Date: "Date",
        TXID: "TXID",
        Reference: "Reference",
        Receipt: 'Receipt',
      },
      dataCopies: {
        invalidReference: "invalid",
      },
      filtros: {
        title: "Sort by",
        servicio: "Utility",
        status: "Status",
        dateNew: "Date newest",
        dateOld: "Date oldest",
      },
    },
  },
  contact: {
    section_1: {
      title: "Get to know all about",
      title1: "Wirebit’s new offer",
      subtitle: "Discover all the benefits of our new crypto card.",
      subtitle2: "Security and Freedom just for you.",
    },
    section_2: {
      help_text: "Do you need any help?",
      meeting_call: "Schedule a call with our advisors",
      call_foreign: "Calls from abroad",
      call_local: "Local calls",
      call_costumer_service: "Costumer service phone",
      send_msg: "Feel free to send us a message!",
      schedule: "Monday to Friday from 8:00 a.m. to 5:00 p.m.",
      time_zone: "Central Mexico time.",
    },
    section_3: {
      donwload_title: "Download",
      donwload_title2: "Wirebit Digital",
      donwload_sub: "Enjoy all the benefits of paying",
      donwload_sub2: "with cryptocurrencies in the real world",
      donwload_sub3: "using our cryptocard.",
    },
  },
  checkout:{
    pending:{
      order_details_title: "Order Details",
      email_input: "Email",
      email_placeholder: "myemail@email.com",
      order: "Order",
      column_title_product: "Product",
      column_title_quantity: "Quantity",
      column_title_price: "Price",
      order_total: "Total",
      payment_title: "Payment method",
      payment_method_title: "Select a method of payment",
      payment_crypto_title: "Select crypto for payment",
      payment_made: "I've sent my payment",
      wirebit_method_name:'Wirebit Transfer',
      wirebit_method_desc:'Instant transfer',
      crypto_method_name:'Blockchain',
      crypto_method_desc:'10 to 30 minutes wait',
    },
    completed:{
      thanks:"Thanks for your purchase!",
      order_in_process_01:"Order",
      order_in_process_02:"completed",
      return:"Return to the commerce",
    },
    waiting:{
      thanks:"Thanks for your purchase!",
      order_in_process_01:"Your order",
      order_in_process_02:"is currently in process",
      return:"Return",
    },
    deposits:{
      deposits_title:"Deposits",
      deposits_TXID_column:"TXID",
      deposits_amount_crypto_column:"Amount",
      deposits_amount_currency_column:"Amount",
    },
    notifications:{
      copy:{
        title:"Copied!",
        message:"The text has been copied to your clipboard"
      },
      error:{
        title:"Error!",
        message:"Use a valid email"
      },
    },
    wirebit_payment:{
      title: "Payment",
      instructions:"Click the link or scan the QR from your Wirebit app to continue with your payment",
      link_title:"Link",
      coin_amount:"Crypto Amount",
    },
    crypto_payment:{
      title: "Payment",
      instructions:"Deposit the amount in the generated address",
      address_title:"Address",
      tag_id:"Tag ID",
      coin_amount:"Crypto Amount",
      warning:"WARNING: You may need to send a little more if your app takes the fee from the withdrawal",
      crypto_method_name:'Blockchain',
    },
    status: {
      cancelled:'cancelled',
      pending:'pending',
      completed:'completed',
      incomplete:'incomplete'
    }
  }
};

export default en;
